import CasinoImageBox from "components/casinoImageBox";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import Appconfig from '../../config/config'
import Loader from "components/loader";
import { useEffect, useState } from "react";
import CasinoLayout from "components/casinoLayout";
import WebSocketEventEmitter from "context/eventEmitter";
import { setProfileData } from "../../redux/slice/auth/authSlice";
import { fetchUserProfile } from "services/users";


function RoyalCasino() {
    const casinoImages = [
        {
            src: '/assets/images/casino/withoutLogin/7-UP-and-Down.webp',
            title: '7 UP and Down',
            provider_code: 'DC',
            game_code: '900001',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Auto-Roulette.webp',
            title: 'Auto Roulette',
            provider_code: 'DC',
            game_code: '900002',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Teen-Patti.webp',
            title: 'Teen Patti',
            provider_code: 'DC',
            game_code: '900003',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Dragon-Tiger.webp',
            title: 'Dragon Tiger',
            provider_code: 'DC',
            game_code: '900027',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Cricket-War.webp',
            title: 'Cricket War',
            provider_code: 'DC',
            game_code: '900005',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Amar-Akbar-Anthony.webp',
            title: 'Amar Akbar Anthony',
            provider_code: 'DC',
            game_code: '900007',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/3-Cards-Judgement.webp',
            title: '3 Cards Judgement',
            provider_code: 'DC',
            game_code: '900008',
            type: ''
        },

        {
            src: '/assets/images/casino/withoutLogin/Casino-War.webp',
            title: 'Casino War',
            provider_code: 'DC',
            game_code: '900009',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Worli-Matka.webp',
            title: 'Worli Matka',
            provider_code: 'DC',
            game_code: '900010',
            type: ''
        },

        {
            src: '/assets/images/casino/withoutLogin/Bollywood-Casino.webp',
            title: 'Bollywood Casino',
            provider_code: 'DC',
            game_code: '900011',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Lottery.webp',
            title: 'Lottery',
            provider_code: 'DC',
            game_code: '900012',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/Book-Cricket.webp',
            title: 'Book Cricket',
            provider_code: 'DC',
            game_code: '900013',
            type: ''
        },

        // {
        //     src: '/assets/images/casino/withoutLogin/High-Low.webp',
        //     title: 'High Low',
        //     provider_code: 'DC',
        //     game_code: '900004'
        // },

        {
            src: '/assets/images/casino/withoutLogin/Muflis-Teen-Patti.webp',
            title: 'Muflis Teen Patti',
            provider_code: 'DC',
            game_code: '900015',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/RG-LIVELOBBY.jpg',
            title: 'Royal Gaming Live Lobby',
            provider_code: 'DC',
            game_code: '900000',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/RG-ARW101.jpg',
            title: 'Akbar Romeo Walter',
            provider_code: 'DC',
            game_code: '900023',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/RG-2TP101.jpg',
            title: '2 Cards Teen Patti',
            provider_code: 'DC',
            game_code: '901019',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/RG-DTL101.jpg',
            title: 'Dragon Tiger Lion',
            provider_code: 'DC',
            game_code: '900031',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/RG-HL01-VR.jpg',
            title: 'HighLow VR',
            provider_code: 'DC',
            game_code: '901014',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901019.RG-2TP101-VR.jpg',
            title: '2 Cards Teenpatti VR',
            provider_code: 'DC',
            game_code: '901019',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901021.RG-AB101-VR.jpg',
            title: 'Andar Bahar VR',
            provider_code: 'DC',
            game_code: '901021',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901028.RG-LK7101-VR.jpg',
            title: 'Lucky7 VR',
            provider_code: 'DC',
            game_code: '901028',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901033.RG-SBC101-VR.jpg',
            title: 'Side Bet City VR',
            provider_code: 'DC',
            game_code: '901033',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901036.RG-TRI101-VR.jpg',
            title: 'Trio VR',
            provider_code: 'DC',
            game_code: '901036',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901009.RG-CAW01-VR.jpg',
            title: 'Casino War VR',
            provider_code: 'DC',
            game_code: '901009',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901023.RG-CAM101-VR.jpg',
            title: 'Casino Meter VR',
            provider_code: 'DC',
            game_code: '901023',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901029.RG-MOC101-VR.jpg',
            title: 'Movie Casino VR',
            provider_code: 'DC',
            game_code: '901029',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901032.RG-RTT101-VR.jpg',
            title: 'Race T20 VR',
            provider_code: 'DC',
            game_code: '901032',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/900021.RG-LK7101.jpg',
            title: 'Lucky7',
            provider_code: 'DC',
            game_code: '900021',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901001.RG-7UD01-VR.jpg',
            title: '7 Up Down VR',
            provider_code: 'DC',
            game_code: '901001',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901003.RG-TP01-VR.jpg',
            title: 'Teen Patti VR',
            provider_code: 'DC',
            game_code: '901003',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901004.RG-DT01-VR.jpg',
            title: 'Dragon Tiger VR',
            provider_code: 'DC',
            game_code: '901004',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901007.RG-AAA01-VR.jpg',
            title: 'Amar Akbar Anthony VR',
            provider_code: 'DC',
            game_code: '901007',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901008.RG-3CJ01-VR.jpg',
            title: '3 Cards Judgement VR',
            provider_code: 'DC',
            game_code: '901008',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901013.RG-BCRIC01-VR.jpg',
            title: 'Dus Ka Dum (Cards) VR',
            provider_code: 'DC',
            game_code: '901013',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901005.RG-CW01-VR.jpg',
            title: 'Cricket War VR',
            provider_code: 'DC',
            game_code: '901005',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901006.RG-BAC01-VR.jpg',
            title: 'Baccarat VR',
            provider_code: 'DC',
            game_code: '901006',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901010.RG-WM01-VR.jpg',
            title: 'Worli Matka VR',
            provider_code: 'DC',
            game_code: '901010',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901011.RG-BOC01-VR.jpg',
            title: 'Bollywood Casino VR',
            provider_code: 'DC',
            game_code: '901011',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901012.RG-LOT01-VR.jpg',
            title: 'Lottery VR',
            provider_code: 'DC',
            game_code: '901012',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901015.RG-MTP01-VR.jpg',
            title: 'Muflis Teen Patti VR',
            provider_code: 'DC',
            game_code: '901015',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901020.RG-32C101-VR.jpg',
            title: '32 Cards VR',
            provider_code: 'DC',
            game_code: '901020',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901022.RG-ARW101-VR.jpg',
            title: 'Akbar Romeo Walter VR',
            provider_code: 'DC',
            game_code: '901022',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901026.RG-DTL101-VR.jpg',
            title: 'Dragon Tiger Lion VR',
            provider_code: 'DC',
            game_code: '901026',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901031.RG-RT17101-VR.jpg',
            title: 'Race To 17 VR',
            provider_code: 'DC',
            game_code: '901031',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901034.RG-SPO101-VR.jpg',
            title: 'Super Over VR',
            provider_code: 'DC',
            game_code: '901034',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901037.RG-TRP101-VR.jpg',
            title: 'The Trap VR',
            provider_code: 'DC',
            game_code: '901037',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901027.RG-FBS101-VR.jpg',
            title: 'Foot Ball Studio VR',
            provider_code: 'DC',
            game_code: '901027',
            type: ''
        },
        {
            src: '/assets/images/casino/withoutLogin/901030.RG-POK101-VR.jpg',
            title: 'Poker VR',
            provider_code: 'DC',
            game_code: '901030',
            type: ''
        },
    ]
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [iframeUrl, setIframeUrl] = useState('');
    const { isAuthenticated } = useSelector((state) => state.authSlice);

    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                if (status === "SUCCESS") {
                    // window.open(response.data.launchURL, "_self");
                    setIframeUrl(response.data.launchURL);
                    setLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                    setLoading(false);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                    setLoading(false);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }


    return (
        <>
            {loading && <Loader />}
            <CasinoLayout casinoImages={casinoImages} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} iframeUrl={iframeUrl} setIframeUrl={setIframeUrl} />
        </>
    );
}

export default RoyalCasino;